/// <amd-module name="Test/ManageTestPlansCommon/SettingsService" />
import { DirectoryPivotType, TelemetryConstants } from "Test/ManageTestPlansCommon/Constants";
import { ITestPlanHubSettingService, IUserOptions } from "Test/ManageTestPlansCommon/Contracts";
import { ITfsPageService } from "Tfs/Platform/Page";
import { IVssPageContext, Services, VssService } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { ISettingsService, SettingsUserScope } from "VSS/Platform/Settings";
import { IVssTelemetryService } from "VSS/Platform/Telemetry";


export class TestPlansHubSettingsService extends VssService implements ITestPlanHubSettingService {

    public _serviceStart(pageContext: IVssPageContext): void {
        super._serviceStart(pageContext);
        const contributionService = pageContext.getService<IVssContributionService>("IVssContributionService");
        this._userOptions = contributionService.getData<IUserOptions>(this._providerId) ||
            TestPlansHubSettingsService.defaultUserOptions;
    }


    public setMostRecentPivot(pivot: DirectoryPivotType): Promise<void> {
        return this.settingsService
            .setEntries({
                [TestPlansHubSettingsService.selectedPivotSettingKey]: pivot
            }, SettingsUserScope.Me, this._projectScopeKey, this._projectId)
            .then(() => {
                this._userOptions.selectedPivot = pivot;
            }, (reason: any) => {

                let errorString = `Could not store pivot settings for Test Plans Hub: ${reason}`;
                this._telemetryService.publishEvent(TelemetryConstants.areaTestManagement,
                    TelemetryConstants.mineAllPage_Error, { error: errorString });
            });
    }

    public setFilterState(pivot: DirectoryPivotType, filterState: string): Promise<void> {
        const settingKey = `${TestPlansHubSettingsService._hubName}/${pivot}/Filter`;

        return this.settingsService
            .setEntries({
                [settingKey]: filterState
            }, SettingsUserScope.Me, this._projectScopeKey, this._projectId)
            .then(() => {
                if (pivot === DirectoryPivotType.all) {
                    this._userOptions.allPlansFilterState = filterState;
                } else {
                    this._userOptions.myPlansFilterState = filterState;
                }
            }, (reason: any) => {
                let errorString = `Could not store pivot settings for Test Plans Hub: ${reason}`;
                this._telemetryService.publishEvent(TelemetryConstants.areaTestManagement,
                    TelemetryConstants.mineAllPage_Error, { error: errorString });
            });
    }

    private get settingsService(): ISettingsService {
        return this.pageContext.getService<ISettingsService>("ISettingsService");
    }

    /**
* Get project id from context
*/
    private get _projectId(): string {
        const tfsPageData = this.pageContext.getService<ITfsPageService>("ITfsPageService").getData();
        if (tfsPageData && tfsPageData.project) {
            const project = tfsPageData.project;
            return project.id;
        }
        else {
            return "";
        }
    }

    private get _telemetryService(): IVssTelemetryService {
        return this.pageContext.getService<IVssTelemetryService>("IVssTelemetryService");
    }    

    public get userOptions(): IUserOptions {
        return this._userOptions;
    }

    public static readonly defaultUserOptions: IUserOptions = {
        myPlansFilterState: "",
        allPlansFilterState: "",
        selectedPivot: DirectoryPivotType.mine
    };

    public static readonly selectedPivotSettingKey = "TestPlanHub/Navigation/SelectedPivot";
    private static readonly _hubName = "Test Plans";
    private _userOptions: IUserOptions;
    private readonly _providerId = "ms.vss-test-web.testplan-hub-user-options-data-provider";
    private readonly _projectScopeKey = "project";
}
Services.add("ITestPlanHubSettingService", {serviceFactory: TestPlansHubSettingsService});